import { formatClock } from '@/lib/match-clock'

type MatchTimerProps = { elapsed: number; running: boolean }

/** Cronometro della partita: "mm:ss", pallino pulsante mentre il timer del server è in corsa. */
export function MatchTimer({ elapsed, running }: MatchTimerProps) {
  return (
    <span className="flex items-center gap-1.5 font-body text-sm tabular-nums text-paper/70" data-testid="match-timer">
      {running && <span className="size-1.5 rounded-full bg-coral motion-safe:animate-pulse" aria-hidden="true" />}
      {formatClock(elapsed)}
    </span>
  )
}
